import { atom } from 'jotai';
import { EmploiDuTemps } from '@teetsh/app/src/types/edt';

export const sendEDTToCMSPayloadAtom = atom<
  | {
      edt: EmploiDuTemps;
    }
  | undefined
>(undefined);
